import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import AddImage from "../../Global Functions/addImage";
import { useDispatch, useSelector } from "react-redux";
import {
  editCategory,
  viewCategory,
} from "../../Redux/Actions/categoryActions";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import ImageShowerModal from "../../Global Functions/imageShowerModal";

const EditCategories = () => {
  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [categoryState, setCategoryState] = useState({
    id: id,
    name: "",
    position: "",
    icon: "",
    three_d_icon: "",
    image: "",
  });

  useEffect(() => {
    dispatch(viewCategory(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const { category } = useSelector((state) => state.categories || {});

  useEffect(() => {
    if (category?.data) {
      setCategoryState((prevData) => ({
        ...prevData,
        ...category?.data,
        id: id,
      }));
    }
  }, [id, category]);

  const handleImageUpload = async (event, type) => {
    const uploadedImage = event.target.files[0];

    if (!uploadedImage) return;

    const responseUrl = await AddImage(uploadedImage);

    if (responseUrl) {
      setCategoryState((prevData) => ({ ...prevData, [type]: responseUrl }));
    }
  };

  const handleAddChange = (event) => {
    const { name, value } = event.target;

    setCategoryState((prevData) => ({ ...prevData, [name]: value }));
  };

  const hanldeSubmit = async (event) => {
    event.preventDefault();
    try {
      if (categoryState) {
        const filteredData = Object.fromEntries(
          Object.entries(categoryState).filter(
            ([_, value]) =>
              value !== "" && (value !== null) & (value !== undefined)
          )
        );
        const response = await dispatch(editCategory(filteredData));
        if (response.statusCode === 200) {
          navigate("/categories");
        }
      }
    } catch (error) {}
  };

  return (
    <MainLayout>
      <div
        style={{
          background: "white",
          width: "100%",
          height: "100%",
          borderRadius: "25px",
          gridColumn: "2/7",
        }}
      >
        <div
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            padding: "0px 20px",
          }}
        >
          <h1>Edit Category</h1>
          <Link to="/categories">
            <button
              style={{
                padding: "15px 20px",
                background: "#172358",
                color: "white",
                borderRadius: "25px",
                fontSize: "16px",
              }}
            >
              Go Back
            </button>
          </Link>
        </div>
        <form style={{ padding: "10px 20px" }}>
          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="image">
                Change Category's Image
              </span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                name="image"
                // value={categoryState.image}
                onChange={(event) => handleImageUpload(event, "image")}
                id="image"
              />
              <label className="label-class-image" for="image">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={categoryState.image}
                setState={setCategoryState}
                state={categoryState}
                keyField="image"
              ></ImageShowerModalGlobal>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="icon">
                Change Category's Icon
              </span>
              <input
                style={{
                  display: "none",
                }}
                onChange={(event) => handleImageUpload(event, "icon")}
                type="file"
                name="icon"
                id="icon"
              />
              <label className="label-class-image" for="icon">
                Click to Upload Icon
              </label>
              <ImageShowerModalGlobal
                file={categoryState.icon}
                setState={setCategoryState}
                state={categoryState}
                keyField="icon"
              ></ImageShowerModalGlobal>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="change-name">
                Change Category Name
              </span>
              <input
                className="input-class"
                type="text"
                name="name"
                value={categoryState.name}
                onChange={handleAddChange}
                placeholder="Enter Name"
              />
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Upload 3D Icon
              </span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                id="three_d_icon"
                onChange={(event) => handleImageUpload(event, "three_d_icon")}
                name="three_d_icon"
              />
              <label className="label-class-image" for="three_d_icon">
                Click to Upload Icon
              </label>
              {categoryState.three_d_icon ? (
                <ImageShowerModal
                  file={categoryState.three_d_icon}
                  onClick={() => {
                    setCategoryState((prevData) => ({
                      ...prevData,
                      three_d_icon: "",
                    }));
                  }}
                ></ImageShowerModal>
              ) : null}
            </div>
          </div>

          <div className="flex-end" style={{ marginTop: "20px" }}>
            <Link to="/categories">
              <button className="button-class-white">Cancel</button>
            </Link>
            <button
              className="button-class"
              type="submit"
              onClick={hanldeSubmit}
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditCategories;
